import { LinearProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { AiMappingTaskSnapshot } from "../aiMappingTask";

interface AiMappingTaskProgressProps {
  label: string;
  snapshot: AiMappingTaskSnapshot | null;
  onCancel: () => void;
}

export default function AiMappingTaskProgress({
  label,
  snapshot,
  onCancel,
}: AiMappingTaskProgressProps) {
  return (
    <MDBox data-testid="ai-mapping-progress">
      <LinearProgress
        variant={snapshot?.isIndeterminate ? "indeterminate" : "determinate"}
        value={snapshot?.progress ?? 0}
      />
      <MDBox display="flex" alignItems="center" gap={1} mt={0.5}>
        <MDTypography variant="caption" color="text" sx={{ flex: 1 }}>
          {snapshot?.isIndeterminate
            ? label
            : `${snapshot?.progress ?? 0}%${
                snapshot?.progressMessage ? ` — ${snapshot.progressMessage}` : ""
              }`}
        </MDTypography>
        <MDButton
          size="small"
          variant="text"
          color="error"
          onClick={onCancel}
          data-testid="ai-mapping-cancel-task"
        >
          Cancel
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
